import icon from 'vue-svgicon';

icon.register({
    'regular/stopwatch': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<circle pid="0" cx="12" cy="14.25" r="9" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 7.5l1.875-1.875M19.5 5.25l.75.75M12 5.25V.75M14.25.75h-4.5M12 15l-3.75-4.151"/>`,
    },
});
